import React, {Component} from 'react'
import { connect } from 'react-redux'
import EventEmitter from '../../utils/events'

// Actions
import { GetSimpleCarRentals } from '../../actions/shops'

// import components
import Header from '../../shared/components/Header'
// import LeftMenu from '../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'

// contants
import { CarRentalSystemTypes } from '../../constants'

// Elements
import Button from '../../shared/elements/button'
import TabBar from '../../shared/elements/tabBar'
import SideMenu from '../../shared/elements/sideMenu'
import SideMenuItem from '../../shared/elements/sideMenuItem'
import SideMenuCustomItem from '../../shared/elements/sideMenuCustomItem'

// Utils
import { translation } from '../../utils/helpers'
import { hasSubscriptionPermission } from '../../utils/auth'

// Views
import View from './View'

// import styles
import './carRental.scss'
import BackButton from '../../shared/elements/backButton'

class CarRental extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'list',
      search: '',
      includeInactive: false,
      carRentals: [],
      activeItem: {},
      brands: []
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.headerButtonsGoBack = this.headerButtonsGoBack.bind(this)
    this.createView = this.createView.bind(this)
    this.renderView = this.renderView.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onSelectItem = this.onSelectItem.bind(this)
    this.GetSimpleCarRentals = this.GetSimpleCarRentals.bind(this)
  }

  componentDidMount () {
    this.GetSimpleCarRentals()
  }

  GetSimpleCarRentals () {
    this.props.GetSimpleCarRentals().then((res) => {
      this.setState({
        carRentals: res.data,
        activeItem: this.state.activeItem
      })
      if (res.data.length === 0) {
        this.changeView('create')
      }
    }, () => {
      console.log('err')
    })
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    if (view === 'create') {
      activeItem = {}
    }
    this.setState({
      view: view,
      activeItem: activeItem
    })
  }

  headerButtonsGoBack () {
    if (this.state.view === 'create') return null

    const goBack = (type) => {
      this.context.router.goBack()
    }
    return <BackButton ariaText={translation('394')} onClick={goBack.bind(this, 'back')} />
  }

  headerButtonsRight () {
    if (!hasSubscriptionPermission(this.props.auth, 10, 11)) return null
    if (this.state.view === 'create') return null
    if (this.props.auth.carRentalSystem === CarRentalSystemTypes.RENTLOG) return null

    return (
      <div>
        <Button spacing={0} size='m' labelText={translation('14773')} ariaText={translation('14773')} onClick={this.changeView.bind(this, 'create')} />
      </div>
    )
  }

  onSave (data, type) {
    let carRentals = [...this.state.carRentals]
    let activeItem
    if (type === 'create') {
      let createdName = ''
      if (data.Number !== 0) {
        createdName += data.Number + ' - '
      }
      createdName += data.RegNumber
      if (data.BrandName !== '2000') {
        createdName += ', ' + data.BrandName
      }
      carRentals.push({
        Id: data.Id,
        RegNumber: data.RegNumber,
        BrandName: data.BrandName,
        Number: data.Number,
        Active: data.Active,
        Name: createdName
      })
      type = 'item'
      activeItem = {
        Id: data.Id
      }
    } else {
      carRentals.map((val, key) => {
        if (val.Id === data.Id) {
          val.RegNumber = data.RegNumber
          val.BrandName = data.BrandName
          val.Number = data.Number
          val.Active = data.Active
          // val.Name = data.Name
        }
      })
      type = 'item'
      activeItem = {
        Id: data.Id
      }
    }
    this.setState({
      carRentals: carRentals,
      view: type,
      activeItem: activeItem
    })
    // Toastr
    // window.toastr.success(translation('14772'), translation('13424'))
  }

  renderView () {
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'create':
      case 'item':
        return (
          <View
            router={this.props.router}
            ref='view'
            onSave={this.onSave}
            itemId={this.state.activeItem.Id}
            GetSimpleCarRentals={this.GetSimpleCarRentals} />
        )
    }
  }

  createView () {
    // If view is create
    if (this.state.view === 'create') {
      const onAdd = () => {
        this.refs.view.getWrappedInstance().updateCarRental()
      }
      return [
        <SideMenuCustomItem key='0' isFixed>
          <Button onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>,
        <SideMenuCustomItem key='1' isFixed>
          <Button style='secondary' onClick={this.changeView.bind(this, 'list')} labelText={translation('570')} />
        </SideMenuCustomItem>
      ]
    }

    return this.state.carRentals.map(cr => {
      return (
        <SideMenuItem
          label={cr.Name}
          onClick={() => this.onSelectItem(cr)}
          selected={cr.Id === this.state.activeItem.Id}
          inactive={!cr.Active}
          key={cr.Id}
        />
      )
    })
  }

  onSelectItem (item) {
    this.setState({
      view: 'item',
      activeItem: item
    })
    EventEmitter.emit('sidebar_trigger', false)
  }

  render () {
    // title={translation('14778')}
    // svg={'/images/svgs/menuicons/lend-White.svg'}
    console.log('props.renderTitles', this.props.renderTitles)
    return (
      <div className='carrental__screen'>
        <Header router={this.props.router} showBack headerButtonsGoBack={this.headerButtonsGoBack} renderRight={this.headerButtonsRight} >
          <TabBar>
            {this.props.renderTitles}
          </TabBar>
        </Header>
        <div className='carrental__screen--inner'>
          <div className='row clearfix' />

          {/* <LeftMenu showFilter items={this.state.carRentals} idField={'Id'} showField={'Name'} onSelectItem={this.onSelectItem} selectedItem={this.state.activeItem} view={this.state.view} onRenderCreate={this.createView} /> */}
          <SideMenu showFilter={this.state.view !== 'create'} hideInactiveCheck={this.state.view === 'create'}>
            {this.createView()}
          </SideMenu>

          <LeftMenuContent className='customers__screen--inner'>
            {this.renderView()}
          </LeftMenuContent>
        </div>
      </div>
    )
  }
}

CarRental.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetSimpleCarRentals,
  hasSubscriptionPermission
})(CarRental)



// WEBPACK FOOTER //
// ./src/app/pages/CarRental/index.js